



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';
import { mapGetters } from 'vuex';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    ...mapGetters({ dashboardDetails: 'getDashboardDetails' }),
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class StoreBuildingPage extends Base {
  public form: any = {};
  public storeBuildingFields: Array<VFields<any>> = [];
  public storeBuildingModel = {
    id: '',
    name: '',
  };

  public storeId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'StoreBuildingTemplates' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'saveStoreBuilding') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreBuilding();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    this.setStoreBuildingFields();

    if (this.$route.params.nameId) {
      this.getBuildings();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setStoreBuildingFields(): void {
    this.storeBuildingFields = [
      {
        key: 'name',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          disabled: false,
          label: 'Name',
          required: true,
          loading: false,
          elementClass:
            'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 float-left',
          rules: [(v) => this.required('Name', v)],
        },
      },
    ];
  }

  public async getBuildings(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeBuildingFields);
      const response = await storeService.getBuildingTemplates(this.storeId);
      const buildingDetail = response.storeJson.templateBuldings.find(
        (m) => m.id == this.$route.params.nameId
      );
      this.storeBuildingModel.name = buildingDetail.value;
      this.storeBuildingModel.id = buildingDetail.id;
    } finally {
      this.formlyHideSkeleton(this.storeBuildingFields);
    }
  }

  public validateStoreBuilding(): Vue & { validate: () => boolean } {
    return this.$refs.storeBuildingForm as Vue & { validate: () => boolean };
  }

  public async saveStoreBuilding(): Promise<void> {
    if (this.validateStoreBuilding().validate()) {
      if (this.validateForm()) {
        try {
          this.requestProgress = true;
          this.$emit('update:progress', this.requestProgress);
          if (this.storeBuildingModel.id === '') {
            await storeService.saveBuildingTemplates(
              this.storeId,
              this.storeBuildingModel
            );
            this.showAlert(true, 'Store building template Added successfully');
            this.$router
              .push({
                name: 'admin.stores.edit',
                params:{
                  tab: 'StoreBuildingTemplates'
                }
              })
              .catch((ex) => {
                console.log(ex);
              });
          } else {
            await storeService.updateBuildingTemplates(
              this.storeId,
              this.storeBuildingModel
            );
            this.showAlert(
              true,
              'Store building template Updated successfully'
            );
            this.$router
              .push({
                name: 'admin.stores.edit',
                params: {
                  storeId: this.storeId.toString(),
                  tab: 'StoreBuildingTemplates'
                },
              })
              .catch((ex) => {
                console.log(ex);
              });
          }
        } finally {
          this.requestProgress = false;
          this.$emit('update:progress', this.requestProgress);
        }
      }
    }
  }
}
